import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I wish my doctor was a vet",
  "description": "",
  "published": "2011-12-01T00:00:00.000Z",
  "redirect_from": ["/blog/i-wish-my-doctor-was-a-vet/swizec/3095"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Over the weekend my cat got seriously ill. She hasn't been eating well for a while, but you know how cats are, they always pull through and with a very hairy kitty you don't even notice there's any `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Weight_loss",
        "title": "Weight loss"
      }}>{`weight loss`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/9cc4d6860ef011e1a87612313804ec91_73.jpg",
        "alt": "My cat",
        "title": "My cat"
      }}></img></p>
    <p>{`I mean, I've seen her avoid eating for several days simply to extort getting tastier food.`}</p>
    <p>{`This time though it was serious - we took her to a vet. Turns out she nearly died and even now we won't know if she's going to pull through until Friday (tomorrow).`}</p>
    <p>{`But that's not what I want to talk about. I want to compare what it's like visiting a veterinary with a sick pet and what it's like for a sick human to visit a regular doctor.`}</p>
    <h2 {...{
      "id": "a-tale-of-two-doctors"
    }}>{`A tale of two doctors`}</h2>
    <p>{`The vet was very busy. They had an emergency surgery going on, there was a dog that needed a long procedure done and we ended up waiting for half an hour before the vet could give the kitty a proper examination.`}</p>
    <p>{`When we got in, through profuse apologies over our half an hour wait, he immediately started explaining possible reasons for the cat's weight loss and explained in detail which tests will be performed. The cat was then sedated, blood was taken and he immediately took it to another room to perform bloodwork.`}</p>
    <p>{`Something about checking kidney, liver and pancreas function. While we were waiting he took on some other pets, but kept coming to check back on us every five minutes or so while the bloodwork was being done - presumably by a machine.`}</p>
    <p>{`The whole thing took about twenty minutes and showed a pretty grim picture. There was a fair chance Kitty had aids because her `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Complete_blood_count",
        "title": "Complete blood count"
      }}>{`white cell count`}</a>{` was practically zero and it looked like her liver might be completely fried. We were shown graphs and carefully explained what they meant.`}</p>
    <p>{`After the aids test came back negative an assistant shaved the cat's tummy and the vet performed ultrasound. I got to see my cat's innards and even though I couldn't really tell what was going on the vet explained it pretty well - not only giving me an aloof explanation and symptoms, but carefully explained the reasoning behind everything he said.`}</p>
    <p>{`Save for picking apart words, I couldn't really understand what he was saying, but the fact he explained everything was very reassuring. Made it look like he wasn't just pulling things out of his arse.`}</p>
    <p>{`Cat has some sort of bacterial infection of the liver and now we have to take her back every day for shots, feed her a carefully selected diet and tomorrow we'll know if she's making a recovery and will be able to eat her meds as pills.`}</p>
    <p>{`Looks good so far, she's started eating pretty well. That's a good sign I think.`}</p>
    <p>{`Oh and the special diet, the medicine we have to give her - all provided by the vet, he even lent us a kitty box so we can transport her to and fro easier since we've lent ours to my gran. The whole visit was over with in about two hours.`}</p>
    <p>{`And the vet spent another five minutes at the end to profusely apologize about the half an hour wait.`}</p>
    <h3 {...{
      "id": "compare-that-to-my-last-brush-with-healthcare"
    }}>{`Compare that to my last brush with healthcare.`}</h3>
    <p>{`A few years ago I got really sick. The kind of sick where a proud doctor-disliking 20-something crawls out of his bedroom one day and asks his mother to take him to the doctor.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/f2ea2d400a7211e1a87612313804ec91_72.jpg",
        "alt": "Geeky cat",
        "title": "Geeky cat"
      }}></img></p>
    <p>{`When we got there it wasn't particularly busy, but we were first reprimanded that we dared come when my personal doctor wasn't working and are forcing somebody else to work. Imagine that! And we didn't even have an appointment or anything, how dare we!?`}</p>
    <p>{`I had such a high fever I wasn't really processing everything, but the doctor said it looks like I might have something weird so I should probably get some bloodwork done.`}</p>
    <p>{`They sent me to a whole other part of the building, where I had to wait in another `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Waiting_room",
        "title": "Waiting room"
      }}>{`waiting room`}</a>{` until somebody could draw my blood. While waiting I got really lightheaded and nearly collapsed into the blood letting chair. I think a couple of nurses actually jumped up and caught me so I didn't fall to the ground.`}</p>
    <p>{`Eventually I made my way back down to the original doctor and waited in the waiting room.`}</p>
    <p>{`When it was finally my turn again i was told that I have some sort of viral `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Angina_pectoris",
        "title": "Angina pectoris"
      }}>{`angina`}</a>{`, which is odd since angina's are usually bacterial infections. But whatever.`}</p>
    <p>{`I was told not to leave home for at least a month since one of the symptoms is swelling of internal organs and any physical exertion could rupture my spleen ... I think with a ruptured spleen you bleed out in a couple of minutes?`}</p>
    <p>{`Nevertheless, I was given antibiotics, because maybe, just maybe, it wasn't a viral angina after all, or it might be both types of angina at once.`}</p>
    <p>{`What?`}</p>
    <p>{`This meant a trip to the pharmacy before going home as well ...`}</p>
    <p>{`The whole thing lasted something like four hours, I visited several different doctors - luckily in the same general building - and was eventually told that the simple act of walking around could kill me.`}</p>
    <h2 {...{
      "id": "public-vs-private"
    }}>{`Public vs. private?`}</h2>
    <p>{`But that's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Public_health",
        "title": "Public health"
      }}>{`public medicine`}</a>{` for you.`}</p>
    <p>{`This probably isn't really a comparison between vets and human doctors, but a comparison between private and public medicine, which really makes me wish I could afford `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Private_healthcare",
        "title": "Private healthcare"
      }}>{`private medicine`}</a>{` and that if I do in fact start affording private medicine, that doesn't mean I have to keep giving god knows how much money to public medicine.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://money.marksandspencer.com/news/2010/09/uninsured-pet-owners-charged-more-by-vets/7310/"
        }}>{`Uninsured pet owners charged more by vets`}</a>{` (money.marksandspencer.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lillij.wordpress.com/2011/11/05/i%e2%80%99ve-been-sick%e2%80%a6-but-now-i%e2%80%99m-all-better/"
        }}>{`I've been sick.... :( But now I'm all better!`}</a>{` (lillij.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://money.marksandspencer.com/news/2010/07/one-third-of-pets-may-be-overweight,-say-vets/7169/"
        }}>{`One third of pets may be overweight, say vets`}</a>{` (money.marksandspencer.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=994bba52-216c-4a62-8e01-b01213c76dae",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      